/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2023
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { SingleDropdown } from '../../../../components/Dropdowns';
import classes from './Header.module.css';
import Button from '../../../../components/Button';
import { BookingStatuses } from './constants';
import { TmsComponents as TmsEnums } from '../../../../enums';
import HeaderMenu from '../HeaderMenu';
import drapDropImg from '../../../../assets/images/TMS/move-white.png';
import strings from '../../../../globalization';

const Header = ({
  openPopup,
  onSelectSensorGroup,
  selectedSensorGroup,
  bookingStatus,
  onChangeBookingStatus,
  onHeaderMenuOptionClick,
  showHelpPopup,
  onToggleDrapDrop,
  isEnabledDragDrop,
}) => {
  const storeInfo = useSelector(state => state.storeInfo);
  const { sensorGroups: sensGroups, serverAppFeatures } = storeInfo?.data || {};
  const { storeLayoutBySensorGroup } = serverAppFeatures || {};
  const sensorGroups = sensGroups?.length ? sensGroups.map(s => ({ label: s.name, value: s.id })) : [];

  const onHelp = () => {
    showHelpPopup(true);
  }

  return (
    <div className={classes.container}>
      <div className={classes.leftsection}>
        <div className={classes.onedineTxt}>{strings.onedineLabel}</div>
        {storeLayoutBySensorGroup && (
          <div className={classes.sensorGrpBtn}>
            <SingleDropdown
              value={selectedSensorGroup}
              closeMenuOnSelect={true}
              onChange={onSelectSensorGroup}
              options={sensorGroups}
              placeholder={strings.selectSensorGrp}
              width={20}
            />
          </div>
        )}
      </div>
      <div className={classes.rightsection}>
        <HeaderMenu onHeaderMenuOptionClick={onHeaderMenuOptionClick} />
        <Dropdowns
          bookingStatus={bookingStatus}
          onChangeBookingStatus={onChangeBookingStatus}
        />
        <div className={classes.subRightSection}>
          <AddButton onOpenCreateBookingPopup={() => openPopup(TmsEnums.tmsCreateBooking)} />
          <DragDrop onClick={onToggleDrapDrop} disabled={!isEnabledDragDrop} />
          <div onClick={onHelp} className={classes.helpIcon}>?</div>
        </div>
      </div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  onOpenSensorGroupPopup: PropTypes.func,
  selectedSensorGroup: PropTypes.object,
  bookingStatus: PropTypes.object,
  onChangeBookingStatus: PropTypes.func,
  openPopup: PropTypes.func,
  onSelectSensorGroup: PropTypes.func,
  onHeaderMenuOptionClick: PropTypes.func,
  onToggleDrapDrop: PropTypes.func,
};

Header.defaultProps = {
  onOpenSensorGroupPopup: () => { },
  selectedSensorGroup: {},
  bookingStatus: {},
  onChangeBookingStatus: () => { },
  openPopup: () => { },
  onSelectSensorGroup: () => { },
  onHeaderMenuOptionClick: () => { },
  onToggleDrapDrop: () => { },
};

const Dropdowns = ({ bookingStatus, onChangeBookingStatus }) => {
  return (
    <React.Fragment>
      <SingleDropdown
        value={bookingStatus}
        closeMenuOnSelect={true}
        onChange={onChangeBookingStatus}
        options={BookingStatuses}
        placeholder={strings.pleaseSelectLabel}
        width={15}
      />
    </React.Fragment>
  );
};

const AddButton = ({ onOpenCreateBookingPopup }) => {
  return (
    <Button className={classes.addBtn} onClick={onOpenCreateBookingPopup}>
      <div className={classes.addBtnTxt}>+</div>
    </Button>
  );
};

const DragDrop = ({ onClick, disabled }) => {
  return (
    <Button className={classes.dragDropBtn} onClick={onClick} style={{ opacity: disabled ? 0.5 : 1 }}>
      <img src={drapDropImg} alt='drag-drop' className={classes.drapDropImg} />
    </Button>
  );
};
